module.exports = __webpack_public_path__ + "img/add_list.0f088c7a.svg";